<template>
  <div style="width: 100%">
    <v-row>
      <v-col cols="12">
        <v-row>
          <v-toolbar flat>
            <v-toolbar-title>
              <h2 class="title primary--text text--darken-1 text-no-wrap mt-0">
                FILTROS
              </h2>
            </v-toolbar-title>
          </v-toolbar>
        </v-row>

        <v-row>
          <select-multiple-unidades
            v-model="unidadesSelecionadas"
            :mapeamento-id="diagnostico.mapeamento.id"
          />
        </v-row>

        <relatorio-gerencial-responsabilidade
          :is-uma-unidade="isUmaUnidade"
          :unidades="unidadesSelecionadas"
          :diagnostico="diagnostico"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RelatorioGerencialResponsabilidade from
'@/views/monitoramento/desempenho/responsabilidade/tabs/RelatorioGerencialResponsabilidade';
import SelectMultipleUnidades from '@/components/SelectMultipleUnidades';

export default {
  name: 'RelatorioGerencialResponsabilidadeGeral',

  components: { RelatorioGerencialResponsabilidade, SelectMultipleUnidades },

  props: {
    diagnostico: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      unidadesSelecionadas: {
        isTodasSelecionadas: null,
        selecionado: [],
        visualizacao: '',
      },
      isUmaUnidade: false,
    };
  },
};
</script>
